import React from 'react';
import { MetaHead } from '../components/MetaHead';
import { TreatmentDetailPage } from './TreatmentDetailPage';

export function CitizenPage() {
  return <TreatmentDetailPage />;
}
